// src/constants/index.js

// API Constants
export const API_ENDPOINT = 'https://api.delyva.app';
export const API_VERSION = '/v1.0';  // If needed for versioning

// Storage Keys
export const TOKEN_KEY = 'auth_token';
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const TOKEN_EXPIRY_KEY = 'token_expiry';

// Status Codes
export const STATUS_CODES = {
  PICKUP: { min: 100, max: 499 },
  IN_TRANSIT: { min: 500, max: 599 },
  DELIVERY: { min: 600, max: 699 },
  RETURN: { min: 700, max: 700 },
  ASSIGN_DRIVER: { min: 655, max: 655 }
};

// Table Settings
export const TABLE_LIMITS = [5, 10, 50, 100];
export const DEFAULT_LIMIT = 5;
export const DEFAULT_PAGE = 1;

// Search Settings
export const SEARCH_DEBOUNCE_MS = 500;

// API Endpoints
export const ENDPOINTS = {
  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  REFRESH_TOKEN: '/auth/refreshToken',
  ORDERS: '/order'
};

// Error Messages
export const ERROR_MESSAGES = {
  LOGIN_FAILED: 'Login failed. Please check your credentials.',
  FETCH_FAILED: 'Failed to fetch orders',
  TOKEN_REFRESH_FAILED: 'Token refresh failed',
  NETWORK_ERROR: 'Network error occurred',
  SESSION_EXPIRED: 'Session expired. Please login again.'
};

// Button Labels
export const BUTTON_LABELS = {
  PICKUP: 'Pickup',
  PICKUP_FAILED: 'Pickup Failed',
  IN_TRANSIT: 'In-Transit',
  DELIVERED: 'Delivered',
  DELIVERY_FAILED: 'Delivery Failed',
  RETURN: 'Return',
  FINDING_DRIVER: 'Finding Driver',
};

// Query Parameters
export const QUERY_PARAMS = {
  RETRIEVE: 'service',
  ORDER_BY: 'desc',
  SORT_BY: 'createdAt'
};